import * as React from 'react';

const Home = ({ width, height }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.7379 4.65142C17.1438 3.33885 14.8562 3.33885 13.2621 4.65142L6.59548 10.141C5.5872 10.9712 5 12.2166 5 13.5341V23.9561C5 26.3816 6.94787 28.3337 9.33333 28.3337H9.66667V24.0003C9.66667 20.5025 12.5022 17.667 16 17.667C19.4978 17.667 22.3333 20.5025 22.3333 24.0003V28.3337H22.6667C25.0521 28.3337 27 26.3816 27 23.9561V13.5341C27 12.2166 26.4128 10.9712 25.4045 10.141L18.7379 4.65142ZM20.3333 28.3337V24.0003C20.3333 21.6071 18.3932 19.667 16 19.667C13.6068 19.667 11.6667 21.6071 11.6667 24.0003V28.3337H20.3333ZM11.9908 3.10749C14.3233 1.18683 17.6767 1.18682 20.0092 3.10749L26.6758 8.59706C28.1482 9.8094 29 11.6224 29 13.5341V23.9561C29 27.4705 26.1722 30.3337 22.6667 30.3337H9.33333C5.82776 30.3337 3 27.4705 3 23.9561V13.5341C3 11.6224 3.85185 9.80941 5.32415 8.59706L11.9908 3.10749Z'
      fill='white'
    />
  </svg>
);

export default Home;
